import CartSummaryLine from "../info/CartSummaryLine";
import {formatDisplayPrice} from "../../../../../res/dataServices/pricing";

const CartConfirmationSummary = ({completedOrder}) => {

    const guidePrice = completedOrder.TotalLines;
    const grandTotal = completedOrder.GrandTotal;
    const charges = completedOrder.charges?.lines;
    const previousPayment = 0;
    const overPayment = 0;
    const chargeRate = 0;
    const surcharge = 0;
    const totalDue = completedOrder.GrandTotal;

    // console.log(paymentDetails)

    return (
        <div className="cart-section">
            {(charges ?? []).map((e,i) =>
                <CartSummaryLine
                    key={i}
                    type={e.C_Charge_ID.Name}
                    price={formatDisplayPrice(e.LineNetAmt)}
                />
            )}
            <CartSummaryLine type="Guide Price" price={formatDisplayPrice(guidePrice)} />
            {Boolean(totalDue !== grandTotal) &&
                <CartSummaryLine type="Sub-Total" price={formatDisplayPrice(grandTotal)} />
            }
            {Boolean(previousPayment) &&
                <CartSummaryLine type="Previous payment" price={"-"+formatDisplayPrice(previousPayment)} />
            }
            {Boolean(overPayment) &&
                <CartSummaryLine type="Over payment" price={formatDisplayPrice(overPayment)} />
            }
            {Boolean(chargeRate) &&
                <CartSummaryLine type={'Credit Card Surcharge '+chargeRate + '%'} price={formatDisplayPrice(surcharge)} />
            }
            <CartSummaryLine type="Total" price={formatDisplayPrice(totalDue)} bold />
        </div>
    )
}

export default CartConfirmationSummary;